import { useSnackbar } from "notistack";
import React from "react";
import { ServiceHelper } from "@modules";
import { staffOrderService } from "@services/Staff";
import { DataTable } from "../Common";
import { DataTableColumn } from "../Common/DataTable/DataTable";
import { useCurrentPageInfo, useModal } from "@hooks";
import { StaffOrderItem } from "@interfaces/StaffOrderItem";

const StaffOrderItemsTable = () => {
    const { permission } = useCurrentPageInfo();
    const { enqueueSnackbar } = useSnackbar();
    const { handleOpenModal } = useModal();

    const handleEditClick = (rowData) => {
        handleOpenModal("EDIT_STAFF_ORDER_ITEM", { itemId: rowData.id });
    };

    const handleDeleteClick = async (rowData: StaffOrderItem | StaffOrderItem[]) => {
        try {
            const ids = ServiceHelper.getIdsListFromRowDataObject(rowData);
            await staffOrderService.deleteStaffOrderItems(ids);
            enqueueSnackbar("Заказ успешно удален", {
                variant: "success",
            });
        } catch (err) {
            const message = err.response.data.error_tooltip;
            enqueueSnackbar(message || "Произошла ошибка при удалении заказа", {
                variant: "error",
            });
        }
    };

    const columns: DataTableColumn<StaffOrderItem>[] = [
        {
            title: "#",
            field: "id",
            defaultSort: "asc",
            width: 50,
        },
        {
            title: "Идентификатор заказа",
            field: "staff_order_id",
            width: "auto",
        },
        {
            title: "Цена",
            field: "static_price",
            width: "auto",
        },
        {
            title: "Количество",
            field: "quantity",
            width: "auto",
        },
        {
            title: "Отклонено",
            field: "rejected",
            type: "boolean",
            width: "auto",
        },
    ];

    return (
        <DataTable<StaffOrderItem>
            fetchFn={staffOrderService.getStaffOrderItems}
            columns={columns}
            displayField="id"
            permission={permission}
            sorting
            search
            onEditClick={handleEditClick}
            onDeleteClick={handleDeleteClick}
            onMassDeleteClick={handleDeleteClick}
        />
    );
};

export default StaffOrderItemsTable;
